import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import svg62 from "../../../assets/svg/svg62.svg";
import { Text } from "recharts";
import { useSelector } from "react-redux";

function SchemeCount() {
  // const data = [
  //   { name: "Public", value: 60, remaining: 180 },
  //   { name: "Community", value: 80, remaining: 160 },
  //   { name: "Private", value: 40, remaining: 200 },
  //   { name: "Asals", value: 20, remaining: 220 },
  // ];
  const url = "api/v2/dashboard/getAllDashboardData"; 
  const { loading,  count,data } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],     
    count: state.fetch.count[url] || 0,    
  }));

  const CustomTick = ({ x, y, payload }) => {
    const label =
      payload.value.length > 7
        ? `${payload.value.slice(0, 6)}…`
        : payload.value;
    return (
      <Text
        x={x}
        y={y + 25}
        textAnchor="middle"
        verticalAnchor="start"
        angle={-45}
        className="font-interSans"
        style={{ fontSize: ".79rem", fontWeight: "400", fill: "#1A1A1A" }}
      >
        {label}
      </Text>
    );
  };
  const total = data?.scheme?.reduce((sum, item) => sum + item?.value, 0);

  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white   w-full h-full">
      <div className="flex items-center justify-between text-[#424242] font-interSans text-[.75rem] font-[500] mb-[1.18rem]">
        <div className="flex items-center gap-x-[.65rem]">
          <span className="">Scheme Count</span>
          <img src={svg62} alt="svg62" />
        </div>

        <div className="bg-[#D6E1F5] rounded-[.5rem] py-[.125rem] px-[.25rem] max-w-[6.875rem] flex items-center justify-center">
           {total}
        </div>
      </div>

      <ResponsiveContainer width="100%" height={250}>
        <BarChart
          data={data?.scheme}
          margin={{ left: -30, bottom: 35 }}
          barCategoryGap={10}
          barGap={0}
        >
          <XAxis
            dataKey="name"
            tick={<CustomTick />}
            // tick={{ angle: -45, dy: 30 }}
            axisLine={true}
            tickLine={true}
          />
          <YAxis
            // domain={[0, 240]}
            // tick={{ dx: 20 }}
            axisLine={true}
            tickLine={true}
          />
          <Tooltip cursor={{ fill: "transparent" }} />

          <Bar dataKey="value" stackId="a" fill="#3B82F6" barSize={30}>
            {data?.scheme?.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={
                  index === 0
                    ? "#4F81BD"
                    : index === 1
                    ? "#0092CC"
                    : index === 2
                    ? "#4FAD5B"
                    : "#4FA5AD"
                }
              />
            ))}
          </Bar>
          <Bar dataKey="remaining" stackId="a" fill="#E5E7EB" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default SchemeCount;
